export enum DeleteReason {
    unsuccessful = "unsuccessful",
    successful = "successful",
    canceled = "canceled"
}